// extracted by mini-css-extract-plugin
export default {"lineNumber":"LineNumber_lineNumber__gSiJa","text":"LineNumber_text__KzIbk"};